'use strict'

import Vue from 'vue'
import axios from 'axios'
import { getCookie, getWebURL, getLocationSearch } from '@/utils/util'
import { resolveBackendLanguageForRequest } from '@/i18n/ajax-headers'

// Full config:  https://github.com/axios/axios#request-config

const config = {
  method: 'post',
  timeout: 60 * 1000,
  headers: {
    sessionId: '',
    'Content-Type': 'application/json'
  }
}

const _axios = axios.create(config)

let isNeedLogin = false

_axios.interceptors.request.use(
  function (config) {
    const { headers, data } = config
    let sessionId = ''
    const cookie = getCookie()
    const searchObj = getLocationSearch()
    if (cookie.userInfo) {
      sessionId = cookie.userInfo.sessionId
    }
    // 跨应用刚落地时优先用 URL sessionId，避免 cookie 尚未同步导致被登出
    if (searchObj.sessionId) {
      sessionId = searchObj.sessionId
    }
    if (searchObj.userInfo) {
      let urlCookie = JSON.parse(decodeURIComponent(searchObj.userInfo))
      sessionId = urlCookie.sessionId
    }
    console.log(sessionId,'sessionId1')
    config.headers.sessionId = sessionId
    config.headers.language = resolveBackendLanguageForRequest()
    
    if (headers['Content-Type'] === "application/json") {
      config.data = JSON.stringify(data)
    } else if (headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      const formData = new FormData()
      for (let key in data) {
        formData.append(key, data[key])
        config.data = formData
      }
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    const { code, data, msg } = response.data
    let result = null
    switch (code) {
      case undefined:
        result = response.data
        break
      case 0: // 请求成功
        result = data || true
        break
      case 20001: // 用户需要重新登录
      case 23002:
      case 23003:
        if (!isNeedLogin) {
          isNeedLogin = true
          window.vbus.$message({
            type: 'error',
            message: '请重新登陆',
            onClose() {
              isNeedLogin = false
              const href = getWebURL('visa') + '/login'
              window.location.href = href
            },
          })
        }
        break
      default:
        window.vbus.$message.error(msg)
        break
    }
    return result
  },
  function (error) {
    return Promise.reject(error)
  }
);

Plugin.install = function (Vue) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios
      }
    },
    $axios: {
      get() {
        return _axios
      }
    },
  });
};

Vue.use(Plugin)

export default Plugin